import { View, StyleSheet } from "react-native";
import ClassCardProgress from "../ClassCardProgress/ClassCardProgress";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

const formatCourseNameWithCode = (courseName, courseCode) => {
  if (courseCode && courseCode.trim()) {
    return `${courseCode} ${courseName}`;
  }
  return courseName;
};

const ClassCardProgressList = ({ courses = [], onPress, hasAnalytics, onEditPress, onAnalyticsPress }) => {
  const { isMedium } = useResponsiveScreen();

  return (
    <View
      role="list"
      accessibilityRole="list"
      aria-label="Classes cards"
      style={isMedium ? styles.container : styles.mobileContainer}>
      {courses.map((course, index) => {
        const displayTitle = formatCourseNameWithCode(course?.name, course?.course_code);
        const hasAnalyticsAction = typeof onAnalyticsPress === "function" && hasAnalytics;

        return (
          <ClassCardProgress
            key={index}
            title={displayTitle}
            onPress={() => onPress(course?.id)}
            progress={course?.progress}
            hasEdit={course?.hasEdit}
            isDraft={course?.isDraft}
            hasAnalytics={hasAnalyticsAction}
            onEditPress={() => onEditPress(course?.id)}
            onAnalyticsPress={hasAnalyticsAction ? () => onAnalyticsPress(course?.id) : undefined}
            thumbnail={course?.thumbnail}
            generationStatus={course?.generationStatus}
            startDate={course?.startDate}
            disabled={course?.disabled}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  mobileContainer: {
    flexDirection: "column",
    gap: 16,
  },
});

export default ClassCardProgressList;
